import { ColorEnum } from '@/constants/color'
import { DeliveryZone } from '@/features/orders/types/app'
import LocationIcon from '@/features/ui/icons/components/LocationIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

type DeliveryZoneInfoProps = Pick<DeliveryZone, 'name' | 'color'>

const DeliveryZoneInfo: FC<DeliveryZoneInfoProps> = ({ name, color }) => {
    return (
        <View style={styles.container}>
            <LocationIcon color={color} width={16} height={16} />
            <Typography.Description size="tiny" font="bold" numberOfLines={1} style={styles.name}>
                {name}
            </Typography.Description>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        maxWidth: 100,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    name: {
        flexShrink: 1,
        color: ColorEnum.GRAY_600,
    },
})

export default DeliveryZoneInfo
